
var body = document.querySelector('body');
var mqls = [
    window.matchMedia('(max-width: 768px)'),
    window.matchMedia('(min-width: 769px) and (max-width: 1023px)'),
    window.matchMedia('(min-width: 1024px)'),
    window.matchMedia('(min-width: 1024px) and (max-device-width: 1366px) and (-webkit-min-device-pixel-ratio: 1.5)')
];
 
function mediaqueryresponse(mql){
    if (mqls[0].matches){ // (max-width: 768px) query matched
        body.classList.remove('tablet');
        body.classList.remove('desktop');
        body.classList.remove('ipad');
        body.classList.add('mobile');
    }
    if (mqls[1].matches){ // (min-width: 769px) and (max-width: 1023px) query matched
        body.classList.remove('mobile');
        body.classList.remove('desktop');
        body.classList.remove('ipad');
        body.classList.add('tablet');
    }
    if (mqls[2].matches){ // (min-width: 1024px) query matched
        body.classList.remove('mobile');
        body.classList.remove('tablet');
        body.classList.remove('ipad');
        body.classList.add('desktop');
    }
    if (mqls[3].matches){ // ipad pro media query
        body.classList.remove('mobile');
        body.classList.remove('tablet');
        body.classList.add('desktop');
        body.classList.add('ipad');
    }
}

for (var i=0; i<mqls.length; i++){
    mediaqueryresponse(mqls[i]); // call listener function explicitly at run time
    mqls[i].addListener(mediaqueryresponse); // attach listener function to listen in on state changes
}

$(function(){
    // Desktop navigation
    $('.desktop .sub-mega-nav__group > li:first-child').each(function() {
        $(this).addClass('active');
    });


   $('.desktop .sub-mega-nav__group--sub-nav').each(function(){
        if ($(this).find('> li').length > 9) {
            $(this).children().addClass('small_width');
        } 
   });
    

    $('.desktop .navbar__list').on('mouseenter', '.navbar__item', function(){
        $('.sub-mega-nav__group > li:first-child').each(function (){
            if (!$(this).hasClass('active')) {
                $(this).addClass('active');
            }
        });
    });

    $('.desktop .sub-mega-nav__group').on('mouseenter', '> li', function(){
        if (!$(this).hasClass('active')) {
            $(this).addClass('active');
        }
    }).on('mouseleave', '> li', function(){
        if ($(this).hasClass('active')) {
            $(this).removeClass('active');
        }
    });

    $('.desktop').on('mouseenter', '.navbar__item', function(){
        if (!$(this).children('.sub-nav.sub-mega-nav').hasClass('active')) {
            $(this).children('.sub-nav.sub-mega-nav').addClass('active');
        }
        if (!$(this).hasClass('navbar__item--active')) {
            $(this).addClass('navbar__item--active');
        }
    }).on('mouseleave', '.navbar__item', function(){
        if ($(this).children('.sub-nav.sub-mega-nav').hasClass('active')) {
            $(this).children('.sub-nav.sub-mega-nav').removeClass('active');
        }
        if ($(this).hasClass('navbar__item--active')) {
            $(this).removeClass('navbar__item--active');
        }
    });
    
    // click on hamburger menu - open/close menu 
    $('body').on('click', '.icon-navicon', function(e) {
        e.preventDefault();
        
        $(this).toggleClass('active');
        $('.navbar').toggleClass('active');
        $('body').toggleClass('navbar-open');
    });
   

    // bind click icon close mobile menu
    $('body').on('click', '.icon-navicon--close', function(e) {
        e.preventDefault();
        
        $('.icon-navicon').removeClass('active');
        $('.navbar').removeClass('active');
        $('body').removeClass('navbar-open');
    });

    // remove sub-mega-nav--active class from .sub-mega-nav, .sub-mega-nav__group--content
    $('body').on('click', '.icon-navicon.active, .icon-navicon--close', function(e) {
        e.preventDefault();
        $('.navbar').find('.sub-mega-nav, .sub-mega-nav__group--content').removeClass('sub-mega-nav--active');
    });

    $('body.mobile, body.tablet').on('click', '.sub-mega-nav__group--sub-nav .inner-sub-nav__item a', function(e) {
        $('.icon-navicon').removeClass('active');
        $('.navbar').removeClass('active');
        $('body').removeClass('navbar-open');
        $('.navbar').find('.sub-mega-nav, .sub-mega-nav__group--content').removeClass('sub-mega-nav--active');
    });

    $('body.desktop').on('click', '.inner-sub-nav__item a', function(e) {
        $(this).closest('li.navbar__item').removeClass('navbar__item--active');
        $(this).closest('.sub-mega-nav').removeClass('active');
    });

    // bind click icon show sub menu mobile
    $('body').on('click', '.icon-navicon--show', function(e) {
        e.preventDefault();

        $(this).next('.sub-mega-nav, .sub-mega-nav__group--content').addClass('sub-mega-nav--active');
    });

    // bind click icon hide sub menu mobile
    $('body').on('click', '.icon-navicon--back', function(e) {
        e.preventDefault();

        $(this).parent('.sub-mega-nav, .sub-mega-nav__group--content').removeClass('sub-mega-nav--active');
    });

    $('body.desktop.ipad').on('click', '.sub-mega-nav__group > li.active > a' , function(e) {
        e.preventDefault();
        console.log($(this));
        $('.sub-mega-nav__group > li.active > a').parent().parent().find('> li').each(function (){
            if ($(this).hasClass('active')) {
                $(this).removeClass('active');
            }
        });
        $(this).parent().addClass('active');
    });

    $('body.desktop.ipad').on('click', '.navbar__item > a' , function(e) {
        e.preventDefault();
    });

    
    // $('.desktop .sub-mega-nav__group > li:first-child').each(function() {
    //     $(this).addClass('active');
    // });

    // $('.desktop.ipad .navbar__list').on('click', '.navbar__item', function(){
    //     $('.sub-mega-nav__group > li:first-child').each(function (){
    //         if (!$(this).hasClass('active')) {
    //             $(this).addClass('active');
    //         }
    //     });
    // });

    // $('.desktop.ipad .sub-mega-nav__group').on('click', ' > li', function(){
    //     $(this).toggleClass('active');
    // });

    //mobile fix scroll
    $('.mobile .sub-mega-nav__group--content-wrapper').css('max-height', window.innerHeight);
    $('a.sub-mega-nav__group--content-child.sub-mega-nav__group--highlighted-area').each(function(){
        $(this).css('height', $(this).innerHeight() + 100);
    });
});


